import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import ThankYou from "@/pages/ThankYou";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import AdminLeads from "@/pages/AdminLeads";
import AdminLogin from "@/pages/AdminLogin";
import AdminPipeline from "@/pages/AdminPipeline";
import AdminSettings from "@/pages/AdminSettings";
import AdminVideos from "@/pages/AdminVideos";
import AdminImages from "@/pages/AdminImages";
import AdminSiteImages from "@/pages/AdminSiteImages";
import AdminPurchaseLinks from "@/pages/AdminPurchaseLinks";
import AdminTransformations from "@/pages/AdminTransformations";
import AdminUsers from "@/pages/AdminUsers";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AcceptInvite from "@/pages/AcceptInvite";
import OutRedirect from "@/pages/OutRedirect";
import CookieBanner from "@/components/CookieBanner";
import LogoIntro from "@/components/LogoIntro";
import { SiteContentProvider } from "@/lib/site-content";
import { initConsentMode, captureAttribution, loadTracking } from "@/lib/tracking";

function App() {
  useEffect(() => {
    initConsentMode();
    captureAttribution();
    loadTracking();
  }, []);
  return (
    <div className="App">
      <SiteContentProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/danke" element={<ThankYou />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/forgot" element={<ForgotPassword />} />
          <Route path="/admin/reset" element={<ResetPassword />} />
          <Route path="/admin/invite" element={<AcceptInvite />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route path="/admin/pipeline" element={<AdminPipeline />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="/admin/videos" element={<AdminVideos />} />
          <Route path="/admin/images" element={<AdminImages />} />
          <Route path="/admin/site-images" element={<AdminSiteImages />} />
          <Route path="/admin/purchase-links" element={<AdminPurchaseLinks />} />
          <Route path="/admin/transformations" element={<AdminTransformations />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/out/:channel" element={<OutRedirect />} />
        </Routes>
        <CookieBanner />
        <LogoIntro />
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "#3A4230",
              color: "#F3F1E8",
              border: "1px solid rgba(255,255,255,0.16)",
            },
          }}
        />
      </BrowserRouter>
      </SiteContentProvider>
    </div>
  );
}

export default App;
